var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',[_c('Dropdown',{attrs:{"title":"Manejar Estatus","variant":"standard m-1","items":_vm.statusTargets.map((x) => ({
        name: x.name,
        click: () => {
          _vm.setCurrentStatusTarget(x);
        },
      })),"icon":"fa fa-check","responsive":false}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }